<template>
	<button :class="classList" :type="method" @click="clicked($event)" ref="element" :disabled="disabled">
		<slot></slot>
	</button>
</template>

<script type="text/babel">
export default {
	props: {
		method: { default: "button" }, // button, submit
		extraClasses: { default: "" },
		type: { default: "regular" }, // regular, outline, outline gray, white, danger, text-only
		variant: { default: "normal" }, // normal, cta
		widthSize: { default: "normal" },
		isLoading: { default: false },
		isFull: { default: false },
		prevent: { default: true },
		disabled: { default: false }
	},

	methods: {
		clicked(event) {
			if (this.prevent) {
				event.preventDefault();
			}

			this.$emit("clicked");
			this.$emit("click");
		},
	},

	computed: {
		classList() {
			let classList = "button";

			classList += " " + this.type;
			classList += " w-size-" + this.widthSize;

			if (this.variant !== "normal") {
				classList += " " + this.variant;
			}

			if (this.isLoading) {
				classList += " is-loading";
			}

			if (this.isFull) {
				classList += " is-full";
			}

			if (this.extraClasses !== "") {
				classList += " " + this.extraClasses;
			}

			return classList;
		},
	},
};
</script>
